import { useContext } from 'react'
import { Illustration } from '@/components/Illustration/Illustration'
import { observer } from 'mobx-react'
import { StoreContext } from '@/store/Root.store'
import { Header } from '@/components/Generic'

export const NotFoundPage = observer(() => {
  const store = useContext(StoreContext)
  const { errorPage: trans } = store.TranslationsState.translations

  return (
    <div className="page-container p-50 mobile-m-10">
      <Illustration type="not-found" />

      <Header className="m-0-0-30">{trans.pageNotFound}</Header>
    </div>
  )
})
